import EventModel from '../EventModel';

import CartInfoModel from './models/CartInfoModel';
import {IEventData} from 'coreClasses/events/IEvents';
import ManagerRepository from 'coreClasses/ManagerRepository';

/**
 * Represents CartUpdatedEventModel
 */
export default class CartUpdatedEventModel extends EventModel {
	public event: string;
	public cartInfo: CartInfoModel;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);
		this.event = data.event;
		this.cartInfo = data.basket && new CartInfoModel(managerRepository, data.basket);
	}

	/**
	 * Checks if event is persistent
	 * @returns {boolean} true if event is persistent
	 */
	public isPersistentEvent() {
		return false;
	}
}
